import { Injectable } from "@angular/core";
import { PrValidationService } from "@irb/irb-editors/editor-portfolio-result/services/pr-validation.service";
import { IPortfolioResultResponse, IPortfolioResultDialogData } from "@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model";
import { AppService } from '@irb/app.service';
import { IrbAppEvents } from '@irb-common/events';
import { IAlertDialogData } from '@irb/app.model';

@Injectable({
  providedIn: "root",
})
export class PrDialogService {
  constructor(private as: AppService, private prvs: PrValidationService) {}

  showStaleDataDialog() {
    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
        dTitle: "Refresh Required",
        dProceedBtnLabel: "Refresh",
        msg: "You are attempting to update a portfolio result that was just modified by someone else. To see the updated portfolio result, you need to refresh the page.",
        onProceed: () => {}
      } as IAlertDialogData);
  }

  isErrorMsg(resp: IPortfolioResultResponse, dilgTitle: string): boolean {
    const errMsg = resp.errMessage;

    if (errMsg && errMsg !== "") {
      if (errMsg === "staleDataException") {
        this.showStaleDataDialog();
      } else {
        const dialogData = {} as IPortfolioResultDialogData;
        dialogData.title = "Status";

        if (dilgTitle) {
          dialogData.title = dilgTitle;
        }
        dialogData.isError = true;
        dialogData.message = errMsg;
        this.prvs.displayPfSummryDialog(resp, dialogData, () => {});
      }

      return true;
    }

    return false;
  }
}
